import React from 'react';

const ClockBadgeIcon = () => (
  <span className="bs-icon-xs bs-icon-rounded bs-icon-primary-light me-2 bs-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icon-tabler-clock-hour-8"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
      <path d="M12 12l-3 2" />
      <path d="M12 7v5" />
    </svg>
  </span>
);

export default ClockBadgeIcon;
